<template>
  <div class="main-container">
    <!-- TODO: Show loading spinner / empty/ not found -->
    <Header
      :showGoBack="!attachmentsMode"
      :title="headerTitle"
      :sub-title="headerSub"
    >
      <div v-if="!attachmentsMode" class="d-flex align-items-center justify-content-end">
        <div v-if="!readOnly">
          <b-button
            variant="outline-danger"
            class="mr-1"
            @click="setReadOnly(true)"
          >
            <span class="mr-1">Cancelar</span>
            <font-awesome-icon :icon="['far', 'times']" fixed-width />
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="updating"
            @click="updateOrder()"
          >
            <span>Guardar</span>
            <b-spinner v-if="updating" small type="grow"></b-spinner>
            <font-awesome-icon  v-else :icon="['far', 'save']" fixed-width />
          </b-button>
        </div>
        <b-dropdown
          v-else
          id="action-btn"
          text="Acción"
          right
          class="m-md-2"
          variant="primary"
          :disabled="!isOsGestor"
        >
          <b-dropdown-item
            :disabled="!isServiceCallRequest || !isOsGestor"
            @click="setReadOnly(false)"
          >
            <font-awesome-icon :icon="['far', 'edit']" class="text-warning" fixed-width />
            <span class="pl-1">Editar</span>
          </b-dropdown-item>
          <b-dropdown-item
            :disabled="!isServiceCallRequest || !isOsGestor"
            @click="showCancelRequestModal = true"
          >
            <font-awesome-icon :icon="['far', 'times-circle']" class="text-danger" fixed-width />
            <span class="pl-1">Anular</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </Header>

    <!-- main content -->
    <b-container fluid class="index-body mt-2">

      <b-alert :show="isServiceCallRequest && isOsGestor && !attachmentsMode" variant="warning" class="mt-2 mb-2">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" fixed-width size="lg" />
        <span class="fs-17">Falta completar información para crear la llamada de servicio en SAP</span>

        <ul v-if="osRequirements.length > 0">
          <li v-for="requirement in osRequirements" :key="requirement">
            {{ requirement }}
          </li>
        </ul>
      </b-alert>

      <b-alert :show="orderWithError && !attachmentsMode" dismissible variant="danger" class="mt-2 mb-2">
        <div>
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width size="lg" />
          <b class="fs-17">Error al sincronizar con SAP:</b>
        </div>
        <ul class="mb-0">
          <li class="fs-17">{{ serviceCall.sap_error }}</li>
        </ul>
        <p class="fs-17 mb-0">Si el problema persiste, contacte a <b>Soporte Técnico</b></p>
      </b-alert>

      <SubheaderCard
        :serviceCall="serviceCall"
      />

      <!-- breadcrumb -->
      <Breadcrumbs
        v-if="!attachmentsMode"
        :steps="steps"
        :current-step="currentStep"
        :label-horizontal="false"
        :clickable="false"
      />

      <!-- tabs -->
      <b-row class="mt-3">
        <b-col>
          <b-tabs
            v-model="tabIndex"
            no-fade
            nav-class="ml-2 mr-2 mb-1 bg-light fs-17 border-0"
            active-nav-item-class="bg-light text-dark fs-17 border rounded border-red"
          >
            <b-card class="fs-17 styled-card" style="min-height: calc(100vh - 30.375rem)">
              <b-tab
                v-for="tab in tabs"
                :key="tab.position"
                :title="tab.title"
                :disabled="tab.disabled"
                title-link-class="font-lato-tab"
              >
                <b-card-text>
                  <div v-if="tab.title == 'Cargando...'" class="d-flex h-100 justify-content-center align-items-center" style="min-height: calc(100vh - 34.375rem)">
                    <div class="d-flex fs-24 text-center text-primary">
                      <b-spinner type="grow"></b-spinner>
                      <span class="pl-2">Cargando datos</span>
                    </div>
                  </div>
                  <div v-if="tab.title == 'Error'" class="d-flex h-100 justify-content-center align-items-center" style="min-height: calc(100vh - 34.375rem)">
                    <div class="d-flex flex-column align-items-center">
                      <div v-if="fetchError == 'OS cerrada'" class="d-flex flex-column align-items-center text-info fs-24 mb-2">
                        <font-awesome-icon :icon="['far', 'info-circle']" size="2xl" fixed-width />
                        <span class="pl-2">
                          La Llamada de Servicio ya se encuentra cerrada
                        </span>
                      </div>
                      <div v-else class="d-flex flex-column align-items-center">
                        <div class="d-flex align-items-center text-center text-danger fs-24 mb-2">
                          <font-awesome-icon :icon="['far', 'times-circle']" size="lg" fixed-width />
                          <span class="pl-2">
                            Hubo un error al consultar
                          </span>
                        </div>
                        <b-button
                          variant="outline-danger"
                          @click="fetchServiceCall"
                        >
                          <span >Intentar nuevamente</span>
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <GeneralTab
                    v-if="tab.title == 'Información'"
                    ref="generalTab"
                    :serviceCall="serviceCall"
                    :event="event"
                    :readOnly="readOnly"
                    :form="form"
                  />

                  <AttachmentsTab
                    v-else-if="tab.title == 'Adjuntos'"
                    ref="photosTab"
                    :attachments="attachments"
                    @onFileAdded="handleFileAdded"
                    @onFileRemoved="handleFileRemoved"
                    @showFullImage="showFullImage"
                  />

                  <TroubleshootingTab
                    v-else-if="tab.title == 'Troubleshooting'"
                    ref="troubleshootingTab"
                    :troubleshooting="serviceCall.ts_solution"
                  />
                </b-card-text>
              </b-tab>
            </b-card>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>

    <ImageFullModal
      v-if="fullImageUrl"
      :image-url="fullImageUrl"
      :disableControls="true"
      @close-modal="fullImageUrl = null"
    />

    <!-- Confirm Modal when updating order -->
    <ConfirmModal
      v-if="showUpdatingModal"
      :processing="false"
      required
      :disabled="false"
      :modal-width="'480px'"
      @close="closeUpdateOrderModal"
      @onConfirm="showUpdatingModal = false"
    >
      <template #header>
        <h5 class="mb-1">
          Orden de Servicio
        </h5>
      </template>

      <template #body>
        <template v-if="updatingStatus == 'updating'">
          <div class="text-center py-3">
            <b-spinner variant="primary" style="width: 2.5rem; height: 2.5rem;" />
            <p class="mt-2 mb-1 font-weight-500 fs-17 text-primary">
              Creando Orden de Servicio
            </p>
            <p class="text-muted small mb-0">El proceso puede tardar unos segundos</p>
          </div>
        </template>

        <template v-else-if="updatingStatus == 'success'">
          <div class="text-center py-2">
            <div class="text-success mx-auto mb-2" style="font-size: 25px;">
              <font-awesome-icon :icon="['fas', 'check-circle']" fixed-width size="2xl" />
            </div>
            <p class="text-success mb-2 fs-18">
              Orden de Servicio registrada en SAP correctamente
            </p>
            <p class="mb-1 fs-15">
              Número de OS: <b>{{ serviceCall.sap_doc_num }}</b>
            </p>
          </div>
        </template>

        <template v-else-if="updatingStatus == 'error'">
          <div class="text-center py-2">
            <div class="text-danger mx-auto mb-2" style="font-size: 25px;">
              <font-awesome-icon :icon="['far', 'times-circle']" fixed-width size="2xl" />
            </div>
            <p class="text-danger mb-1 fs-18">
              Error al crear la OS en SAP
            </p>
            <p class="text-muted fs-15 mb-1">
              Por favor, inténtelo de nuevo o contacte a Soporte Técnico
            </p>
          </div>
        </template>

        <template v-else>
          <div class="text-center py-2">
            <div class="text-info mx-auto mb-2" style="font-size: 25px;">
              <font-awesome-icon :icon="['far', 'info-circle']" fixed-width size="2xl" />
            </div>
            <p class="text-center mb-1 fs-16 mt-3 text-secondary">
              <span>Se creará la Orden de Servicio en SAP</span>
            </p>
          </div>
        </template>
      </template>

      <template #footer>
        <b-button
          variant="outline-danger"
          :disabled="updatingStatus == 'updating'"
          @click="closeUpdateOrderModal"
        >
          <span>Cerrar</span>
        </b-button>
        <b-button
          v-if="updatingStatus == 'error'"
          variant="outline-primary"
          :disabled="updatingStatus == 'success' || updatingStatus == 'updating'"
          @click="updateOrder()"
        >
          <span v-if="updatingStatus == 'error'">Reintentar</span>
          <span v-else-if="updatingStatus == 'updating'">Actualizando</span>
        </b-button>
      </template>
    </ConfirmModal>

    <!-- Confirm Modal when canceling order -->
    <ConfirmModal
      v-if="showCancelRequestModal"
      :processing="false"
      required
      modalWidth="450px"
      :disabled="!requestCancelForm.closing_notes || requestCancelForm.closing_notes.length < 12 || requestCancelForm.closing_notes.length > 250"
      @close="onCloseRequestCancelModal"
      @onConfirm="cancelRequest"
    >
      <template #header>
        <h5>Anulación de Solicitud</h5>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <div>
              <p class="font-weight-bold mb-1 fs-17">¿Confirma la anulación de esta solicitud?</p>
              <p class="text-muted text-justify fs-15">Esta acción anulará definitivamente la solicitud y quedará registrada en el historial del sistema</p>
            </div>
            <!-- justificación -->
            <b-row>
              <b-col>
                <b-textarea
                  v-model="requestCancelForm.closing_notes"
                  rows="4"
                  placeholder="Describa detalladamente el motivo por el cual se realiza la anulación"
                  trim
                  :state="requestCancelForm.closing_notes && requestCancelForm.closing_notes.length > 12 && requestCancelForm.closing_notes.length < 250 ? true : false"
                ></b-textarea>
                <small v-if="requestCancelForm.closing_notes && requestCancelForm.closing_notes.length > 250" class="text-danger">
                  La justificación no puede exceder los 250 caracteres
                </small>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </ConfirmModal>

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>

  </div>
</template>

<script>
import { normalize, schema } from 'normalizr'
import { mapGetters } from 'vuex'

import Header from '../Header'
import Breadcrumbs from '../Breadcrumbs'
import GeneralTab from './GeneralTab'
import AttachmentsTab from './AttachmentsTab'
import TroubleshootingTab from './TroubleshootingTab'
import SubheaderCard from './SubheaderCard.vue'

import ImageFullModal from '../../../shared/ImageFullModal'
import ToastAlert from '../../../shared/ToastAlert'
import ConfirmModal from '../../../shared/ConfirmModal'

export default {
  name: "Show",
  components: { Header, Breadcrumbs, GeneralTab, AttachmentsTab, TroubleshootingTab, ImageFullModal, SubheaderCard, ToastAlert, ConfirmModal},
  data() {
    return {
      id: Number(this.$route.params.id),
      fetchError: null,
      fullImageUrl: null,
      loading: false,
      serviceCall: {},
      documentData: {},
      documentList: [],
      photoData: {},
      photoList: [],
      event: {},
      tabIndex: 0,
      tabs: [
        { position: 0, title: 'Cargando...', disabled: false }
      ],
      baseSteps: [
        { label: 'Solicitud', step: 0, icon: null, done: false },
        { label: 'Por Agendar', step: 1, icon: null, done: false },
        { label: 'Coordinada', step: 2, icon: null, done: false },
        { label: 'En sitio', step: 3, icon: null, done: false },
        { label: 'Entregado', step: 4, icon: null, done: false }
      ],
      processingFile: false,
      readOnly: true,
      form: {
        client: {
          client_code: null,
          client_name: null,
          client_id: null,
          payment_terms: null
        },
        contact: {
          solicited_by: null,
          telephone: null,
          contact_email: null,
          client_contact_id: null,
        },
        address: {
          address: null,
          geo_location: null,
          assistance_type: null,
          client_address_id: null,
        },
        service: {
          system_type: null,
          problem_type_name: null,
          due_on: null,
          sap_series: null,
          call_type: null,
          subject: null,
          item_serial_no: null,
          is_recurring: null,
          payment_type: null,
          warranty_evaluation_required: null,
          comments: null
        }
      },
      formErrors: [],
      alertShow: false,
      alertVariant: null,
      alertMessage: '',
      updating: false,
      showUpdatingModal: false,
      updatingStatus: null,
      // service call request
      requestCancelForm: {
        closing_notes: null
      },
      showCancelRequestModal: false
    }
  },
  mounted() {
    this.fetchServiceCall()
  },
  watch: {
    '$route.query' (to, from) {
      this.fetchServiceCall()
    }
  },
  computed: {
    ...mapGetters(['isDev', 'isOsGestor']),
    isServiceCallRequest () {
      if (this.loading) return false
      if (!this.serviceCall.id) return false
      if (this.serviceCall.sap_service_call_id) return false

      return this.serviceCall.service_step === 'service_call_request'
    },
    headerTitle () {
      if (this.loading) return 'Cargando llamada de servicio...'
      if (this.updating) return 'Actualizando llamada de servicio...'
      if (!this.serviceCall.id) return 'No se encontró la llamada de servicio'
      if (this.attachmentsMode) return `Llamada de Servicio #${this.serviceCall.sap_doc_num} | Adjuntos`

      if (this.serviceCall.service_step === 'service_call_request') {
        return `Solicitud de OS`
      }

      return `Llamada de Servicio #${this.serviceCall.sap_doc_num}`
    },
    headerSub () {
      if (this.loading) return ''
      if (!this.serviceCall.id) return ''
      if (this.attachmentsMode) return 'Documentos adjuntos'

      return this.isServiceCallRequest ? `Creada por: ${this.serviceCall.created_by.first_name} ${this.serviceCall.created_by.last_name}` : 'Información detallada de la OS'
    },
    attachments () {
      const documents = this.documentList.map(id => ({...this.documentData[id], type: 'document', file_id: '', origen: 'ticket'}))
      const photos = this.photoList.map(id => ({...this.photoData[id], type: 'image', file_id: '', origen: 'ticket'}))
      // TODO: Add videos when implemented in app

      const attachments = documents.concat(photos)
      return attachments.sort((a, b) => a.created_at > b.created_at ? -1 : 1)
    },
    isRequestPending () {
      if (this.serviceCall.sap_service_call_id) return false

      return ['service_call_request', 'ready_for_sap'].includes(this.serviceCall.service_step)
    },
    currentStep () {
      if (!this.serviceCall.id) return -1
      if (this.isRequestPending) return 0 // Solicitud
      if (!this.event?.start_at) return 1 // Por Agendar

      const statuses = (this.event.dispatches || []).map(d => d.status)
      if (statuses.some(s => ['entregado', 'validacion'].includes(s))) return 4 // Entregado
      if (statuses.includes('recibido')) return 3 // En sitio

      return 2 // Coordinada
    },
    steps () {
      const current = this.currentStep
      const lastStep = this.baseSteps.length - 1

      return this.baseSteps.map(step => ({
        ...step,
        done: current >= 0 && (step.step < current || current === lastStep)
      }))
    },
    orderWithError () {
      if (!this.isDev) return false
      if (!this.isOsGestor) return false

      return this.serviceCall.sap_error && !this.serviceCall.sap_is_synced
    },
    osRequirements () {
      if (this.loading) return []
      if (!this.serviceCall.id) return []
      if (!this.isOsGestor) return []
      if (this.serviceCall.sap_service_call_id) return []


      const requirements = []
      if (this.serviceCall.client_id) {
        if (this.serviceCall.client.sap_frozen || !this.serviceCall.client.sap_valid) {
          requirements.push('CLIENTE INACTIVO: Debe activar el cliente en SAP para poder generar la llamada de servicio')
        }
      }


      return requirements
    },
    attachmentsMode () {
      const { attachments } = this.$route.query
      if (attachments === 'true') return true

      return  false
    }
  },
  methods: {
    fetchServiceCall () {
      this.loading = true
      this.$http.get(`/api/production/service_calls/${this.id}`)
        .then(response => {
          // console.log(response)
          this.buildTabs()
          this.serviceCall = response.data
          this.event = response.data.event || {}
          this.formatAttachments(this.serviceCall.documents, this.serviceCall.photos)
          this.formatFormData(this.serviceCall)
          this.fetchError = null

          delete this.serviceCall['documents']
          delete this.serviceCall['photos']
          delete this.serviceCall['event']
        })
        .catch(error => {
          console.log(error.response.data.error);
          const response_code = error?.response?.data?.error || ''
          this.tabs = [
            { position: 0, title: 'Error', disabled: false }
          ]
          if (response_code == 'Service Call is closed') {
            this.fetchError = 'OS cerrada'
          } else {
            this.fetchError = ''
          }

        })
        .finally(() => {
          this.loading = false
        })
    },
    formatFormData (serviceCall) {
      this.form = {
        client: {
          client_code: serviceCall.client_code,
          client_name: serviceCall.client_name,
          client_id: serviceCall.client_id,
          payment_terms: serviceCall?.client?.payment_terms
        },
        contact: {
          solicited_by: serviceCall.solicited_by,
          telephone: serviceCall.telephone,
          contact_email: serviceCall.contact_email,
          client_contact_id: serviceCall.client_contact_id
        },
        address: {
          address: serviceCall.address,
          geo_location: serviceCall.geo_location,
          assistance_type: serviceCall.assistance_type,
          client_address_id: serviceCall.client_address_id
        },
        service: {
          system_type: serviceCall.system_type,
          problem_type_name: serviceCall.problem_type_name,
          due_on: serviceCall.due_on,
          sap_series: serviceCall.sap_series,
          call_type: serviceCall.call_type_before_type_cast == 0 ? null : serviceCall.call_type_before_type_cast,
          subject: serviceCall.subject,
          item_serial_no: serviceCall.item_serial_no,
          is_recurring: serviceCall.is_recurring,
          payment_type: serviceCall.payment_type,
          warranty_evaluation_required: serviceCall.warranty_evaluation_required,
          comments: serviceCall.comments
        }
      }
    },
    buildTabs () {
      if (this.attachmentsMode) {
        this.tabs = [
          { position: 1, title: 'Adjuntos', disabled: false },
        ]
        return
      }

      this.tabs = [
        { position: 1, title: 'Información', disabled: false },
        { position: 2, title: 'Adjuntos', disabled: false },
        { position: 3, title: 'Troubleshooting', disabled: false }
      ]
    },
    normalizeData (items) {
      const normalized = normalize(
        { items },
        { items: [new schema.Entity('items')] }
      )

      return {
        data: normalized.entities.items || {},
        list: normalized.result.items
      }
    },
    // attachments
    formatAttachments (documents, photos) {
      const { data: documentData, list: documentList } = this.normalizeData(documents)
      const { data: photoData, list: photoList } = this.normalizeData(photos)


      this.documentData = documentData
      this.documentList = documentList

      this.photoData = photoData
      this.photoList = photoList
    },
    handleFileAdded (form) {
      if (this.processingFile) { return }
      this.processingFile = true
      const resource = form.type == 'image' ? 'photos' : 'documents'
      const body = form.type == 'image' ?
                    { photo: { image: form.image, caption: form.caption }
                    } : { document: { file: form.file, name: form.name } }

      this.$http.post(`/api/production/service_calls/${this.serviceCall.id}/${resource}`, body)
        .then((res) => {
          // console.log(res.data)
          if (resource === 'photos') {
            const photo = res.data.photo
            photo.type = 'image'
            photo.file_id = form.file_id
            photo.img_url = form.preview

            this.photoData[photo.id] = photo
            this.photoList.unshift(photo.id)
          } else {
            const document = res.data.document
            document.file_id = form.file_id
            document.type = 'document'

            this.documentData[document.id] = document
            this.documentList.unshift(document.id)
          }
        })
        .catch(e => {
        })
        .finally(this.processingFile = false)
    },
    handleFileRemoved (file) {
      const resource = file.type == 'image' ? 'photos' : 'documents'
      let localFile = {}

      if (file.type == 'image') {
        localFile = this.photoList.map(id => this.photoData[id])?.find(p => (p?.file_id === file.file_id) || (p?.id === file.id)) || {}
        if (!localFile.id) return
      } else {
        localFile = this.documentList.map(id => this.documentData[id])?.find(p => (p?.file_id === file.file_id) || (p?.id === file.id)) || {}
        if (!localFile.id) return
      }

      if (this.processingFile) return
      this.processingFile = true

      this.$http.delete(`/api/production/service_calls/${this.serviceCall.id}/${resource}/${localFile.id}`)
        .then((resp) => {
          if (resource === 'photos') {
            delete this.photoData[localFile.id]
            this.photoList = this.photoList.filter(id => id !== localFile.id)
          } else {
            delete this.documentData[localFile.id]
            this.documentList = this.documentList.filter(id => id !== localFile.id)
          }
        })
        .catch(e => {
          // console.log(e)
        })
        .finally(()=> {
          this.processingFile = false
        })
    },
    showFullImage (imageUrl) {
      this.fullImageUrl = imageUrl
    },
    // edit mode
    setReadOnly (mode) {
      if (!this.isServiceCallRequest) return
      if (this.readOnly === mode) return

      if (mode === false) {
        this.formatFormData(this.serviceCall)
      }
      this.readOnly = mode
    },
    async updateOrder () {
      if (this.updating) return

      this.formErrors = []
      await this.validateForm()

      if (this.formErrors.length > 0) {
        this.displayAlert({ message: 'Hay errores en el formulario, debe completar todos los campos requeridos', variant: 'danger' })
        return
      }

      this.updating = true
      this.openUpdateOrderModal()
      const dataToUpdate = this.formatUpdateBody()

      this.$http.patch(`/api/production/service_calls/${this.id}`, {
        ...dataToUpdate
      })
        .then((response) => {
          // console.log(response)
          this.serviceCall = response.data
          this.formatFormData(this.serviceCall)
          this.pingSapStatus()
        })
        .catch(error => {
          this.updatingStatus = 'error'
          this.updating = false
        })
    },
    openUpdateOrderModal () {
      this.showUpdatingModal = true
      this.updatingStatus = 'updating'
    },
    closeUpdateOrderModal () {
      this.showUpdatingModal = false
      this.updating = false
      this.updatingStatus = null
    },
    async pingSapStatus () {
      const MAX_ATTEMPTS = 7
      const INTERVAL_MS = 4000

      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        if (!this.updating) break

        await new Promise(resolve => setTimeout(resolve, INTERVAL_MS))

        try {
          const { data } = await this.$http.get(`/api/production/service_calls/${this.id}/sap_status`)

          const finished = data.sap_is_synced || data.sap_error !== null

          if (!finished) continue

          if (data.sap_is_synced && data.sap_service_call_id) {
            this.serviceCall = {
              ...this.serviceCall,
              ...data
            }
            this.updatingStatus = 'success'
            this.updating = false
            this.readOnly = true
          } else {
            this.updatingStatus = 'error'
            this.serviceCall.sap_error = data.sap_error
            this.serviceCall.sap_is_synced = false
            this.updating = false
          }
          return

        } catch (error) {
          this.updatingStatus = 'error'
          this.serviceCall.sap_error = data.sap_error
          this.serviceCall.sap_is_synced = false
          this.updating = false

          return
        }
      }

      this.updatingStatus = 'error'
      this.updating = false
    },
    formatUpdateBody () {
      return {
        service_call: {
          client_code: this.form.client.client_code,
          client_name: this.form.client.client_name,
          client_id: this.form.client.client_id,
          solicited_by: this.form.contact.solicited_by,
          contact_person: this.form.contact.solicited_by,
          telephone: this.form.contact.telephone,
          contact_email: this.form.contact.contact_email,
          client_contact_id: this.form.contact.client_contact_id,
          address: this.form.address.address,
          geo_location: this.form.address.geo_location,
          assistance_type: this.form.address.assistance_type,
          client_address_id: this.form.address.client_address_id,
          system_type: this.form.service.system_type,
          problem_type_name: this.form.service.problem_type_name,
          due_on: this.form.service.due_on,
          sap_series: this.form.service.sap_series,
          call_type: this.form.service.call_type,
          subject: this.form.service.subject,
          item_serial_no: this.form.service.item_serial_no,
          is_recurring: this.form.service.is_recurring,
          payment_type: this.form.service.payment_type,
          warranty_evaluation_required: this.form.service.warranty_evaluation_required,
          comments: this.form.service.comments,
          sap_error: null,
          sap_is_synced: false
        },
        create_on_sap: true
      }
    },
    async validateForm () {
      const errors = []

      const refs = this.$refs || {}

      const generalTab = refs.generalTab[0] || {}
      if (generalTab && generalTab.checkFormValidity) {
        const result = await generalTab.checkFormValidity()
        if (!result) {
          errors.push('Hay errores en el formulario')
        }
      }

      this.formErrors = errors
    },
    displayAlert ({ message, variant }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
      setTimeout(() => this.alertShow = false, 5000)
    },
    onCloseRequestCancelModal () {
      this.requestCancelForm.closing_notes = null
      this.showCancelRequestModal = false
    },
    cancelRequest () {
      if (this.updating) { return }
      this.updating = true

      this.$http.patch(`/api/production/service_calls/${this.id}/close_request`, {
        service_call: {
          closing_notes: this.requestCancelForm.closing_notes
        }
      })
        .then(response => {
          // console.log(response)
          this.updating = false
          this.showCancelRequestModal = false
          this.$router.replace({ name: 'ServiceCallIndex' })
        })
        .catch(error => {
          console.log(error)
          this.updating = false
          this.displayAlert({ message: 'Error al anular la solicitud, intente de nuevo', variant: 'danger' })
        })
    }
  }
}
</script>

<style scoped>
.main-container {
  background: #F7F7F8;
  color: #1a1a1a;
}
.index-body {
  min-height: calc(100vh - 169px);
  padding: 0 20px;
  margin: 0 auto;
  flex: 1;
}
.styled-card {
  border-radius: 8px;
  border: 2px solid #e2e8f0;
}
</style>
